import React from 'react';
import { SupportStage } from '../../data/industryData';
import '../../styles/SupportStages.css';


interface SupportStagesProps {
  stages: SupportStage[];
}

const SupportStages: React.FC<SupportStagesProps> = ({ stages }) => {
  return (
    <div className="support-stages-section">
      <div className="support-stages-container">
        <h2 className="support-stages-title">How We Support Your Journey</h2>
        <p className="support-stages-subtitle">
          Our comprehensive approach ensures you get the right level of support at every stage
        </p>
        
        <div className="support-stages-grid">
          {stages.map((stage, index) => (
            <div className="our-services-card">
            <div className="our-services-icon">
              <img src={stage.image} alt="Cloud Migration" />
            </div>
            <h3 className="our-service-title">{stage.title}</h3>
            <p className="our-service-description">
              {stage.description}
            </p>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupportStages; 